import { DisplayValue, isNullOrUndefined } from '@adaptiva/core/common';
import { UiService } from '@adaptiva/core/ui';
import { BaseWidgetComponent, WidgetService } from '@adaptiva/core/widgets';
import { CpeInfo, ECpeInfoPart, IProductInfo } from '@adaptiva/metadata/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges, forwardRef } from '@angular/core';

@Component({
	standalone: false,
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'ada-cpe-info-editor',
	templateUrl: './cpe-info-editor.component.html',
	providers: [
		WidgetService,
		{ provide: BaseWidgetComponent, useExisting: forwardRef(() => CpeInfoEditorComponent) },
	]
})
export class CpeInfoEditorComponent extends BaseWidgetComponent implements OnChanges {

	@Input()
	public partIsDisabled: boolean = false;

	@Input()
	public cpeInfo: CpeInfo;

	@Input()
	public validationMessage: string;

	public cpePartOptions: DisplayValue[] = ECpeInfoPart.displayValues();

	constructor(
		public ui: UiService,
		_widgetService: WidgetService
	) {
		super(_widgetService);
	}

	public override ngOnChanges(_changes: SimpleChanges): void {
		super.ngOnChanges(_changes);
		if (_changes.hasOwnProperty('cpeInfo'))
			this.detectChanges();

	}

	public validate(): boolean {
		this.validationMessage = this.cpeInfo.validate();
		this.detectChanges();
		return isNullOrUndefined(this.validationMessage);
	}
}
